<div class="footer-info-container fx-wrap-sm d-flex-row d-flex-col-sm">
    <div class="copy-right col-fx-50-sm pb-10-sm pt-10-sm">
        <p class="p-0-sm">© Copyright 2021 Macurian Inc. All rights reserved.</p>
        <p class="p-0-sm lh-12-sm">Macurian's Privacy Statement does not apply to the third-party content and linked websites.</p>
    </div>
    <div class="payment-info col-fx-50-sm d-block-sm ml-auto">
        <img src="./assets/images/payment-options-sml3.png" class="float-right obj-ft-none">
    </div>
</div>